import { Header, Stack, StackItem } from '@asgard/ui-library';
import { faDownload, faFileSignature } from '@fortawesome/pro-solid-svg-icons';
import { PageContentContainer } from 'components/layout/Page.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { HeroStyles as S } from './Hero.styled';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { useRouter } from 'next/router';

export const Hero: React.FC = () => {
  const { t } = useI18n('freelance-companies');
  const { locale } = useRouter();

  return (
    <S.Root>
      <PageContentContainer containerSize="xlMax">
        <S.OuterWrapper>
          <S.Content>
            <Stack direction="column">
              <StackItem>
                <Header editorial as="h1" size="5xl">
                  {t('freelance-companies.hero.title')}
                </Header>
                <HtmlTrans
                  ns="freelance-companies"
                  i18nKey={'freelance-companies.hero.subtitle'}
                />
              </StackItem>

              <S.CTAs>
                <S.StyledButtonLink
                  href="#companiesForm"
                  schema="brand1"
                  variant="hard"
                  label={t('freelance-companies.hero.cta1')}
                  startIcon={faFileSignature}
                  size="s"
                />

                <S.StyledButtonLink
                  href={`${getAppUrl(APP_URLS.blog, locale)}${
                    locale === 'en'
                      ? '/guide-how-to-work-with-freelance-in-tech'
                      : '/guia-como-trabajar-con-freelance-en-tech-manfred'
                  }`}
                  schema="brand1"
                  variant="ghost"
                  label={t('freelance-companies.hero.cta2')}
                  startIcon={faDownload}
                  size="s"
                />
              </S.CTAs>
            </Stack>

            <StackItem>
              <img
                src={getPublicPath(
                  '/images/freelance-companies/hero-image.png'
                )}
                alt="Freelance companies"
                width="700"
                height="528"
              />
            </StackItem>
          </S.Content>
        </S.OuterWrapper>
      </PageContentContainer>
    </S.Root>
  );
};
